<mat-toolbar>
  <button mat-icon-button matTooltip="Volver al dashboard" routerLink="/contenedores">
    <mat-icon color="primary">arrow_back</mat-icon>
  </button>
  Movimientos
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    @if (canAltaMovimiento()) {
      <button mat-menu-item (click)="newMovimiento()"><mat-icon color="primary">add_circle_outline</mat-icon> Añadir movimiento</button>
    }
    <button mat-menu-item (click)="saveExcel()"><mat-icon color="primary">description</mat-icon> Exportar tabla</button>
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='tableHeader'>
    <mat-form-field class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
    </mat-form-field>
    <mat-form-field class="searchMobile">
      <mat-label>Tipo</mat-label>
      <mat-select [(value)]="tipo" (selectionChange)="getMovimientos()">
        <mat-option value="all">Todos</mat-option>
        <mat-option value="entrega">Entrega</mat-option>
        <mat-option value="retirada">Retirada</mat-option>
        <mat-option value="cambio">Cambio</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef > </th>
        <td mat-cell *matCellDef="let element" class='miniCell'>
          @if (canManageContenedores()) {
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon matTooltip="Acciones">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editarMovimiento(element.id)">
                <mat-icon color="primary">create</mat-icon>
                <span>Ver/Modificar</span>
              </button>
              <button mat-menu-item (click)="deleteMovimiento(element.id)">
                <mat-icon color="primary">delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          }
        </td>
      </ng-container>
      <!--<ng-container matColumnDef="tipo">
      <th mat-header-cell *matHeaderCellDef class='minWidth'> Tipo </th>
      <td mat-cell *matCellDef="let element" class='minWidth'>
        <mat-icon *ngIf="element.tipo === 'entrega'" class='green' matTooltip="Entrega">arrow_forward</mat-icon>
        <mat-icon *ngIf="element.tipo === 'retirada'" class='orange' matTooltip="Retirada">arrow_back</mat-icon>
        <mat-icon *ngIf="element.tipo === 'cambio'" color="primary" matTooltip="Cambio">sync_alt</mat-icon>
      </td>
    </ng-container>-->
    <ng-container matColumnDef="contenedorEntrega">
      <th mat-header-cell *matHeaderCellDef class='minWidth'> Contenedor/es </th>
      <td mat-cell *matCellDef="let element" class='minWidth'>
        @if (element.tipo === 'entrega') {
          <mat-icon class='green miniIcon' matTooltip="Entrega">arrow_forward</mat-icon>
        }
        @if (element.tipo === 'retirada') {
          <mat-icon class='green miniIcon' matTooltip="Retirada">arrow_back</mat-icon>
        }
        @if (element.tipo === 'cambio') {
          <mat-icon class='green miniIcon' matTooltip="Entrega">arrow_forward</mat-icon>
        }
        {{element.contenedorEntregaMatricula}}
        @if (element.tipo === 'cambio') {
          <br>
          }
          @if (element.tipo === 'cambio') {
            <mat-icon class='orange miniIcon' matTooltip="Retirada">arrow_back</mat-icon>
          }
          {{element.contenedorRetiradaMatricula}}
        </td>
      </ng-container>
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Fecha </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.fecha}} </td>
      </ng-container>
      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Cliente </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.cliente}} </td>
      </ng-container>
      <ng-container matColumnDef="albaran">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Nº Albarán </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.albaran}} </td>
      </ng-container>
      <ng-container matColumnDef="observaciones">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Observaciones </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.observaciones}} </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="6">No existen movimientos...
          @if (canAltaMovimiento()) {
            <br> <button mat-stroked-button (click)="newMovimiento()">Añadir movimiento</button>
          }
        </td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
</div>
